import App from 'app/app.js';

function LtMyFavouriteCtrl($scope, ContentStore, LooksStore) {
  this.isViewOpen = true;

  this.init = function () {};

  this.openMyFavouritesView = function () {
    this.isViewOpen = !this.isViewOpen;
  };

  this.getMyFavouritesTooltipText = function () {
    return ContentStore.getContent('DETAIL', 'MY_FAVORITES_TOOLTIP');
  };

  this.isSelectedLook = function (index, look) {
    return $scope.choosedLook && $scope.choosedLook.lookNumber == look.lookNumber;
  };

  this.changeLook = function (look) {
    $scope.changeLook({
      look: look
    });
    if (document.getElementById('image')) {
      document.getElementById('image').scrollIntoView({ behavior: 'smooth' });
    }
  };
}

App.controller('LtMyFavouriteCtrl', ['$scope', 'ContentStore', 'LooksStore', LtMyFavouriteCtrl]);
